import { ShieldCheck, Target, Handshake, Award } from "lucide-react";

const VALUES = [
  {
    icon: ShieldCheck,
    title: "Integridad Absoluta",
  },
  {
    icon: Target,
    title: "Precisión Técnica",
  },
  {
    icon: Handshake,
    title: "Lealtad al Cliente",
  },
  {
    icon: Award,
    title: "Noblesse Oblige",
  },
];

const ABOUT_IMG =
  "https://images.pexels.com/photos/7433840/pexels-photo-7433840.jpeg";

export default function About() {
  return (
    <section
      id="nosotros"
      data-testid="about-section"
      className="relative py-24 lg:py-32 bg-[#FAFAFA]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          {/* Image column */}
          <div className="lg:col-span-5 reveal">
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-24 h-24 border-t border-l border-[#E97906]" />
              <div className="absolute -bottom-4 -right-4 w-24 h-24 border-b border-r border-[#E97906]" />
              <img
                src={ABOUT_IMG}
                alt="Equipo Sagitta Corporativo"
                className="relative w-full aspect-[4/5] object-cover"
              />
            </div>
            <div className="mt-8 hidden lg:block">
              <div className="eyebrow mb-3">Despacho Boutique</div>
              <p className="font-serif-display italic text-lg text-neutral-700 leading-snug max-w-sm">
                “Donde convergen la arquitectura legal y la ingeniería
                contable.”
              </p>
            </div>
          </div>

          {/* Text column */}
          <div className="lg:col-span-7">
            <div className="reveal eyebrow mb-5">¿Quiénes somos?</div>
            <h2 className="reveal font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-neutral-950">
              El pilar estratégico donde convergen la{" "}
              <span className="italic text-[#E97906]">arquitectura legal</span>{" "}
              y la ingeniería contable.
            </h2>

            <div className="reveal mt-8 space-y-6 text-neutral-700 text-base lg:text-[17px] leading-relaxed">
              <p>
                En Nobleza Corporativa Sagitta, somos el pilar estratégico donde
                convergen la arquitectura legal y la ingeniería contable para
                ofrecer soluciones de alta especialidad. Nos distinguimos por
                ser un despacho boutique que transforma la complejidad normativa
                en ventajas competitivas para empresas y profesionales, mediante
                consultorías técnicas y auditorías de precisión.
              </p>
              <p>
                Nuestra esencia radica en la nobleza de nuestro servicio: un
                compromiso inquebrantable con la rectitud, la protección
                jurídica y la transparencia financiera de quienes nos confían su
                trayectoria.
              </p>
              <p>
                En Sagitta nos rigen los valores de:{" "}
                <strong className="text-neutral-950 font-semibold">
                  Integridad Absoluta, la Precisión Técnica, la Lealtad al
                  Cliente y la Noblesse Oblige
                </strong>
                , entendiendo que nuestra posición nos obliga a actuar con la
                máxima responsabilidad profesional.
              </p>
            </div>

            {/* Values grid */}
            <div className="reveal mt-12 grid sm:grid-cols-2 gap-px bg-neutral-200 border border-neutral-200">
              {VALUES.map((v) => {
                const Icon = v.icon;
                return (
                  <div
                    key={v.title}
                    data-testid={`value-${v.title.toLowerCase().replace(/\s/g, "-")}`}
                    className="group bg-white p-7 flex items-start gap-4 hover:bg-[#FFF7F0] transition-colors duration-500"
                  >
                    <span className="shrink-0 inline-flex items-center justify-center w-11 h-11 border border-neutral-200 group-hover:border-[#E97906] group-hover:text-[#E97906] transition-colors">
                      <Icon size={20} />
                    </span>
                    <div>
                      <div className="font-serif-display text-lg leading-snug text-neutral-950">
                        {v.title}
                      </div>
                      <div className="text-xs uppercase tracking-[0.22em] text-neutral-500 mt-1">
                        Valor rector
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            <p className="reveal mt-10 font-serif-display italic text-xl text-neutral-800">
              Contáctanos, vamos a trabajar juntos.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
